var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main"},[_c('PageNavbar'),_c('main',{staticClass:"content"},[_c('div',{staticClass:"container"},[(false)?_c('PageHeader'):_vm._e(),_c('router-view')],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }